<template>
    <div class="notification">
        <span class="count" v-if="totalCount > 0" v-cloak>
            {{totalCount}}
        </span>
        <div class="notificationPopover popover bs-popover-bottom" role="tooltip" style="display:none;">
            <div class="arrow"></div>
            <div class="popover-header">
                <div class="readAll" v-if="totalCount > 0" @click="onClickReadAll">
                    全部標示已讀 ( {{totalCount}} )
                </div>
                系統通知
            </div>
            <div class="popover-body">
                <transition-group name="fade" tag="div">
                    <template
                        v-for="(Notify, key) in Notifys" v-if="Notify.title"
                    >
                        <div
                            class="item"
                            :key="key"
                            :ff-notifyId="Notify.id"
                            @click="onClickReadItem(Notify.id)"
                        >
                            <div>
                                <span class="readIt" @click.stop="onClickReadItAction(Notify.id)">標記已讀</span>
                                {{Notify.title}}
                            </div>
                            <p>{{Notify.content}}</p>
                            <span class="updatedAt">{{Notify.updatedAt}}</span>
                        </div>
                    </template>
                </transition-group>
                <div class="searchStatus" v-if="searching">
                    資料搜尋中 ...
                </div>
                <div class="searchStatus" v-else-if="totalCount === 0">
                    您目前沒有未讀的通知
                </div>
                <div class="searchStatus" v-else-if="canSearchMore === 'no'">
                    您沒有其它未讀的通知
                </div>
            </div>
            <a :href="readAllHref" class="readMore">
                查看全部
            </a>
        </div>
    </div>
</template>

<script>
import ff from 'FF/Helpers/FFHelper';
import Echo from "laravel-echo";
global.Pusher = require("pusher-js");

export default {
    props: ["readAllHref"],
    data: () => {
        return {
            searching: false,
            canSearchMore: false,
            totalCount: 0,
            Notifys: [],
            isFocus: false,
            originalTitle: "",
            currentTitle: "",
            titleHandler: null,
            userId: Number(Json.UserID) ?? 0,
        };
    },
    methods: {
    // 根據查詢增加結果
    async addResult() {
        if (this.searching == true || this.canSearchMore == "no") {
            return false;
        }

        this.searching = true;
        let response;

        var data = {
            idNotIn: []
        };

        for (let key in this.Notifys) {
            data.idNotIn.push(this.Notifys[key]?.id);
        }

        let whileLoop = true;
        let ajaxRequestTime = 0;
        while( whileLoop )
        {
            response = await this.getPageDataResponse( $("base").attr("href") + "api/notification/getListJson", data, ajaxRequestTime);
            ajaxRequestTime++;

            if( response || ajaxRequestTime > 3 )
            {
                whileLoop = false;
            }
        }

        let pageData = response.data;

        this.searching = false;

        this.totalCount = pageData.totalCount;

        if (pageData.Notifys && pageData.Notifys.length > 0)
        {
            for (var key in pageData.Notifys)
            {
                this.Notifys.push(pageData.Notifys[key]);
            }
        }
        else
        {
            this.canSearchMore = "no";
        }
    },
    // // 根據查詢變更結果
    async changeResult() {
        if (this.searching == true)
        {
            return false;
        }

        this.searching = true;
        this.Notifys = [];
        let data = {};
        let response;

        let whileLoop = true;
        let ajaxRequestTime = 0;
        while( whileLoop )
        {
            response = await this.getPageDataResponse( $("base").attr("href") + "api/notification/getListJson", data, ajaxRequestTime);
            ajaxRequestTime++;

            if( response || ajaxRequestTime > 3 )
            {
                whileLoop = false;
            }
        }

        let pageData = response.data;

        if (pageData.Notifys && pageData.Notifys.length > 0)
        {
            this.Notifys = pageData.Notifys;

            this.searching = false;

            this.totalCount = pageData.totalCount;

            if (pageData.Notifys.length < pageData.count)
            {
                this.canSearchMore = "no";
            }
            else
            {
                this.canSearchMore = "yes";
            }
        }
        else
        {
            this.searching = false;
            this.canSearchMore = "no";
        }
    },
    changeTitle(message) {
        var title = document.querySelector("title");
        title.text = message;
        this.currentTitle = title.text;
        document.getElementsByTagName("head")[0].appendChild(title);
    },
    changeFavicon(faviconPath) {
        var link = document.querySelector("link[rel*='icon']");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = faviconPath;
        document.getElementsByTagName("head")[0].appendChild(link);
    },
    playNotificationSound(Audio) {
        // Audio.src = "audio/j45RzFrAzdD.mp3";
        Audio.src = "audio/notification.mp3";

        let playPromise = Audio.play();
        if (playPromise !== undefined) {
        playPromise
            .then(() => {
            Audio.play();
            })
            .catch(() => {});
        }
    },
    async sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    async getPageDataResponse( link, data, ajaxRequestTime) {

        let response;
        try {
            response = await axios.get( link, data );
        }
        catch( error )
        {
            if( error.response.status == 500 || ajaxRequestTime > 1 )
            {
                global.Message.show(
                    '網路連線緩慢，將於 30 秒後自動重新整理'
                );
                await this.sleep(30000);
                return false;
            }
        }

        return response;
    },
    onScrollNotificationPoverBody() {
        if (
            $(".notificationPopover .popover-body").scrollTop() !== 0 &&
            Math.ceil(
            $(".notificationPopover .popover-body").scrollTop() +
                $(".notificationPopover .popover-body").height() +
                300
            ) >= Math.ceil($(".notificationPopover .popover-body")[0].scrollHeight)
        ) {
            this.addResult();
        }
    },
    onClickNotificationPopover( event ){
        if (
            $(event.target).hasClass("notification") === true ||
            ($(event.target).hasClass("count") === true &&
            $(event.target).parents(".headerBar .notification").length > 0)
        ) {
            if ($(".notificationPopover").css("display") == "none") {
            $(".notificationPopover").css("display", "block");
            } else {
            $(".notificationPopover").css("display", "none");
            }

            event.stopPropagation();
        } else if (
            $(event.target).hasClass("notification") === false &&
            $(event.target).hasClass("readIt") === false &&
            $(event.target).hasClass("readAll") === false &&
            $(event.target)
            .parents(".headerBar .notification")
            .length > 0
        ) {
        } else if (
            $(event.target).hasClass("notification") === false &&
            $(event.target)
            .parents(".headerBar .notification .item .readIt")
            .length == 0 &&
            $(event.target)
            .parents(".headerBar .notification")
            .length > 0
        ) {
            event.stopPropagation();
        } else {
            $(".notificationPopover").css("display", "none");
        }
    },
    onClickReadAll() {
        $(".notificationPopover").css("display", "none");
        this.Notifys = [];
        this.totalCount = 0;
        $.ajax({
            url: $("base").attr("href") + "api/notification/readAll",
            type: "POST",
            dataType: "json"
        })
        .done( (response) => {} )
        .fail( (xhr) => {} );
    },
    onClickReadItAction( notifyId ) {

        for ( let key in this.Notifys) {
            if ( this.Notifys[key]?.id == notifyId ) {
                this.Notifys.splice(key, 1);
                $.ajax({
                    url:
                    $("base").attr("href") + "api/notification/readById?id=" +  notifyId,
                    type: "POST",
                    dataType: "json"
                })
                .done((response) => {
                    response = JSON.parse( JSON.stringify( response ) );
                    this.totalCount = response.totalCount;
                })
                .fail((xhr) => {});

                return false;
            }
        }
    },
    bindEcho() {
        if ( location.host !== '127.0.0.1' && location.host !== 'localhost' )
        {
            global.Echo = new Echo({
                broadcaster: "pusher",
                key: Json.pusherAppKey,
                cluster: "us2",
                encrypted: true,
                authEndpoint: Json.url + "/broadcasting/auth"
            });

            // channel 第一個參數填寫 User class path
            // channel 綁定的參數必須跟 Laravel Echo 綁定同樣位置

            global.Echo.private("App.User.User." + this.userId).notification(
                notification => {
                    //收到通知時如果瀏覽器是沒有聚焦的，則改變favicon以及發出聲響
                    //收到通知時如果瀏覽器是聚焦的，則發出聲響
                    //收到通知後用戶如果再次聚焦瀏覽器，則變回原來的favicon
                    if (this.isFocus) {
                        this.playNotificationSound(new Audio());
                    } else {
                        //瀏覽器聚焦時 不改變icon
                        this.changeFavicon("img/favicon-notification.ico");
                        this.playNotificationSound(new Audio());
                        // let message = "您收到新的通知";
                        // if (!this.titleHandler) {
                        //   this.titleHandler = setInterval(() => {
                        //     if (!this.isFocus) {
                        //       this.changeTitle(
                        //         this.currentTitle != message ? message : this.originalTitle
                        //       );
                        //     }
                        //   }, 2000);
                        // }
                    }
                    this.changeResult();
                }
            );
        }
    },
    onClickReadItem(notifyId) {
        for ( let key in this.Notifys) {
            if (this.Notifys[key].id == notifyId) {
                location.href =
                $("base").attr("href") + "api/notification/readToPage?id=" + notifyId;
                return false;
            }
        }
    },
    },
    created() {
      this.isFocus = document.hasFocus();
      window.onfocus = () => {
          this.isFocus = true;
          this.changeFavicon("img/favicon.ico");
      };

      window.onblur = () => {
          this.isFocus = false;
      };
      this.changeResult();
    },
    beforeMount() {

    },
    mounted: function() {
        var _this = this;

        this.originalTitle = document.querySelector("title").text;
        this.currentTitle = document.querySelector("title").text;
        this.bindEcho();
        //
        //

        document.querySelector('.notificationPopover .popover-body').addEventListener('scroll', this.onScrollNotificationPoverBody, true);

        document.addEventListener('click', this.onClickNotificationPopover, false);

    }
};
</script>
